import request from "@utils/request"

export function postGoodsOrderExcel(data) {
    return request({
        url: '/service/mg/con/report/upload/goodsOrderExcel',
        method: 'POST',
        data,
    })
}


export function postGoodsSubOrderExcel(data) {
    return request({
        url: '/service/mg/con/report/upload/goodsSubOrderExcel',
        method: 'POST',
        data,
    })
}
